import { useEffect, useState } from "react";
import { api } from "./api";

let cachedStats = null;
let cachedConfig = null;

export function useStats() {
  const [stats, setStats] = useState(cachedStats || {});
  useEffect(() => {
    if (cachedStats) return;
    api.get("/stats").then((r) => {
      cachedStats = r.data.stats || {};
      setStats(cachedStats);
    }).catch(() => {});
  }, []);
  return stats;
}

export function useConfig() {
  const [config, setConfig] = useState(cachedConfig || {});
  useEffect(() => {
    if (cachedConfig) return;
    api.get("/config").then((r) => {
      cachedConfig = r.data || {};
      setConfig(cachedConfig);
    }).catch(() => {});
  }, []);
  return config;
}
